import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import DoneIcon from "@mui/icons-material/Done";
import DangerousIcon from "@mui/icons-material/Dangerous";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const useStyles = makeStyles(styles);
const menuscolumn = [
  { field: "id", headerName: "ID", width: 50, headerAlign: "center" },
  {
    field: "name",
    headerName: "Tên",
    width: 300,
    headerAlign: "center",
  },
  { field: "path", headerName: "Đường dẫn", width: 250, headerAlign: "center" },
  {
    field: "component",
    headerName: "Component",
    width: 300,
    headerAlign: "center",
  },
];
export default function Menu() {
  const classes = useStyles();
  const [listmenu, setListmenu] = React.useState([]);
  const [openthemmenu, setOpenmenu] = React.useState(false);
  const [openupdatemenu, setOpenupdatemenu] = React.useState(false);
  const [openxoamenu, setOpenxoamenu] = React.useState(false);
  const [openwarning, setOpenWarning] = React.useState(false);
  const [openUpLoadFile, setOpenUpLoadFile] = React.useState(false);
  const [warrningContent, setWarrningContent] = React.useState("");
  const [deleteLoaiMenu, setDeleteLoaiMenu] = React.useState("");
  const [deleteId, setDeleteId] = React.useState("");
  const [value, setValue] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(50);
  const [updateObj, setUpdateObj] = React.useState({});
  const [addObj, setAddObj] = React.useState({});

  const [alert, setAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [icon, setIcon] = React.useState(AddAlert);
  const [color, setColor] = React.useState("warning");
  const [openUpLoadTable, setOpenUpLoadTable] = React.useState(false);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  // Xử lú API
  const token = localStorage.getItem("token");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getListMenu = () => {
    var url = Config.backend + "/api/Menu/getmenu";
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setListmenu(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  const themMenu = () => {
    var url = Config.backend + "/api/Menu/themMenu";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        path: addObj.path,
        name: addObj.name,
        component: addObj.component,
        layout: addObj.layout,
        sub: addObj.sub,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handleClose();
        getListMenu();
        showNotification("Thêm menu thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handleClose();
        console.error("Error fetching data: ", error);
        showNotification("Thêm Menu thất bại", DangerousIcon, "danger");
      });
  };

  const suaMenu = () => {
    var url = Config.backend + "/api/Menu/capnhatmenu?id=" + updateObj.id;
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        path: updateObj.path,
        name: updateObj.name,
        component: updateObj.component,
        layout: updateObj.layout,
        sub: updateObj.sub,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handleupdateClose();
        getListMenu();
        showNotification("Cập nhật menu thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handleupdateClose();
        console.error("Error fetching data: ", error);
        showNotification("Cập nhật Menu thất bại", DangerousIcon, "danger");
      });
  };

  const xoaLoaiMenu = () => {
    var url = Config.backend + "/api/Menu/xoamenu?id=" + deleteId;
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handlexoaClose();
        getListMenu();
        showNotification("Xóa menu thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handlexoaClose();
        console.error("Error fetching data: ", error);
        showNotification("Xóa Menu thất bại", DangerousIcon, "danger");
      });
  };

  const uploadMenu = () => {
    if (value.length < 1) {
      setWarrningContent("Chưa upload file !!!");
      setOpenWarning(true);
    } else {
      console.log(JSON.stringify(value));
    }
  };

  const uploadData = () => {
    handleCloseUploadTable();
  };

  const openThemLoaiMenu = () => {
    setOpenmenu(true);
  };

  const openXoaLoaiMenu = () => {
    if (deleteId === "") {
      setWarrningContent("Bạn chưa chọn  menu cần xóa !!!");
      setOpenWarning(true);
    } else {
      setOpenxoamenu(true);
    }
  };

  const showNotification = (ms, icon, color) => {
    setAlert(true);
    setMessage(ms);
    setIcon(icon);
    setColor(color);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };

  const handleupdateClose = () => {
    setOpenupdatemenu(false);
    setUpdateObj({});
  };
  const handlexoaClose = () => {
    setOpenxoamenu(false);
    setDeleteLoaiMenu("");
    setDeleteId("");
  };
  const handleClose = () => setOpenmenu(false);
  const handleCloseWarning = () => setOpenWarning(false);
  const handleCloseUpload = () => {
    setOpenUpLoadFile(false);
  };
  const handleCloseUploadTable = () => {
    setOpenUpLoadTable(false);
    setValue([]);
  };

  React.useEffect(() => {
    getListMenu();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <FormControl style={{ width: "12%", marginTop: 5 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={openThemLoaiMenu}
            style={{ height: 25 }}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "10%", marginTop: 5, marginLeft: 10 }}>
          <Button
            variant="contained"
            onClick={openXoaLoaiMenu}
            style={{ height: 25 }}
            color="warning"
          >
            Xóa
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={listmenu}
            columns={menuscolumn}
            checkboxSelection={false}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setUpdateObj(params.row);
                event.defaultMuiPrevented = true;
                setOpenupdatemenu(true);
              }
            }}
            onRowClick={(params, event) => {
              setDeleteLoaiMenu(params.row.name);
              setDeleteId(params.row.id);
              event.defaultMuiPrevented = true;
            }}
            rowHeight={30}
            headerHeight={35}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color={color}
            icon={icon}
            message={message}
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridItem>

      {/* S--Thêm  menu--S */}
      <Modal
        open={openthemmenu}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <h6
                    className={classes.cardTitleWhite}
                    style={{ marginTop: "-5px" }}
                  >
                    Thêm menu
                  </h6>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên menu"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              name: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên path"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              path: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên component"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              component: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên layout"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              layout: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Sub"
                          variant="outlined"
                          size="small"
                          type="number"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              sub: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ height: 25 }}
                      onClick={themMenu}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleClose}
                      color="warning"
                      style={{ height: 25, marginLeft: 10 }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Thêm  menu--E */}
      {/* S--Sửa  menu--S */}
      <Modal
        open={openupdatemenu}
        onClose={handleupdateClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Cập nhật menu
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleupdateClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên menu"
                          variant="outlined"
                          size="small"
                          value={updateObj.name == null ? "" : updateObj.name}
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              name: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên path"
                          variant="outlined"
                          size="small"
                          value={updateObj.path == null ? "" : updateObj.path}
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              path: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên component"
                          variant="outlined"
                          size="small"
                          value={
                            updateObj.component == null
                              ? ""
                              : updateObj.component
                          }
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              component: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Tên layout"
                          variant="outlined"
                          size="small"
                          value={
                            updateObj.layout == null ? "" : updateObj.layout
                          }
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              layout: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Sub"
                          variant="outlined"
                          size="small"
                          type="number"
                          value={updateObj.sub == null ? "" : updateObj.sub}
                          onChange={(event) => {
                            const obj = {
                              ...updateObj,
                              sub: event.target.value,
                            };
                            setUpdateObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={suaMenu}
                      style={{ height: 25 }}
                    >
                      Cập nhật
                    </Button>
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={handleupdateClose}
                      style={{ height: 25, marginLeft: 10 }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Sửa  menu--E */}

      {/* S--Xóa  menu--S */}
      <Modal
        open={openxoamenu}
        onClose={handlexoaClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Xóa menu
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handlexoaClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>
                        Bạn có muốn xóa menu <strong>{deleteLoaiMenu}</strong> ?
                      </h5>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      variant="contained"
                      onClick={xoaLoaiMenu}
                      color="primary"
                      style={{ height: 25 }}
                    >
                      Xóa
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handlexoaClose}
                      color="warning"
                      style={{ height: 25, marginLeft: 10 }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Xóa  menu--E */}

      {/* S--Warning modal--S */}
      <Modal
        open={openwarning}
        onClose={handleCloseWarning}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Warning
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>{warrningContent}</h5>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleCloseWarning}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Warning menu--E */}

      {/* S--Upload modal--S */}
      <Modal
        open={openUpLoadFile}
        onClose={handleCloseUpload}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Upload
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={uploadMenu}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleCloseUpload}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Upload  menu--E */}
      {/* S--Upload modal--S */}
      <Modal
        open={openUpLoadTable}
        onClose={handleCloseUploadTable}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Upload
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <div style={{ height: 400, width: "100%" }}>
                      <DataGrid
                        getRowId={(row) => row.id}
                        rows={value}
                        columns={value}
                        checkboxSelection={false}
                        rowHeight={30}
                        headerHeight={45}
                        sx={{
                          [`& .${gridClasses.cell}`]: {
                            py: 1,
                          },
                          [`& .center`]: {
                            justifyContent: "center !important",
                          },
                        }}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) =>
                          setPageSize(newPageSize)
                        }
                        rowsPerPageOptions={[20, 50, 100]}
                        pagination
                      />
                    </div>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={uploadData}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleCloseUploadTable}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Upload  roles--E */}
    </GridContainer>
  );
}
